/* eslint-disable react/no-array-index-key */
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

function MissingDDXTooltip() {
  return (
    <Tooltip
      placement="left-start"
      title={
        <Box sx={{ backgroundColor: 'common.white', p: 3, borderRadius: 1 }}>
          <Typography variant="body2" fontSize="16px" color="red" mb={2}>
            You must consciously choose DDX option for your campaign
          </Typography>
          <Typography variant="body2" fontSize="12px" color="red" mt={2}>
            The plan cannot be saved
          </Typography>
        </Box>
      }
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: 'common.white',
            color: 'text.primary',
            boxShadow: 3,
            maxWidth: 300,
          },
        },
      }}
    >
      <Stack
        flexDirection="row"
        alignItems="center"
        sx={{ position: 'relative' }}
      >
        <ErrorIcon
          color="warning"
          fontSize="small"
          sx={{ position: 'absolute', right: '-25px', top: '-20px' }}
        />
      </Stack>
    </Tooltip>
  );
}

export default MissingDDXTooltip;
